import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermisosService } from '../services/permisos.service';

export const roleGuard = (allowedRoles: string[]): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const permisosService = inject(PermisosService);
    const router = inject(Router);

    if (!authService.isAuthenticated) {
      router.navigate(['/login']);
      return false;
    }

    // Comportamiento original: rol OK → pasa.
    if (authService.hasRole(allowedRoles)) {
      return true;
    }

    // Fix 2026-09-20: cuando el user tiene permisos granulares asignados,
    // dejamos pasar el guard aunque su cargo no matchee (backend hara el
    // chequeo fino con require_permiso). Cierra la queja "empleado con
    // permisos otorgados no puede entrar a nada". Nunca aplica al rol
    // alumno (ese va a su propio home siempre).
    const cargo = authService.userRole?.toLowerCase() || '';
    if (cargo === 'alumno') {
      router.navigate(['/alumnos/home']);
      return false;
    }

    return permisosService.getMisPermisos().pipe(
      map((mp) => {
        const tienePermisos = mp.is_superadmin || (mp.permisos_ids?.length ?? 0) > 0;
        if (tienePermisos) return true;
        router.navigate(['/colaboradores/home']);
        return false;
      }),
      catchError(() => {
        // Si falla la consulta, degradamos al comportamiento antiguo:
        // sin permisos comprobables, denegar como antes.
        router.navigate(['/colaboradores/home']);
        return of(false);
      }),
    );
  };
};
